module.exports = __webpack_public_path__ + "static/media/play.65243dc9.svg";